import { Component, ContentChildren, EventEmitter, Input, OnInit, Output, QueryList, TemplateRef } from '@angular/core';

@Component({
  selector: 'split-table-card',
  templateUrl: './split-table-card.component.html',
  styleUrls: ['./split-table-card.component.scss']
})
export class SplitTableCardComponent implements OnInit {
  @Input() public data: Array<any> = [];
  @Output() public dataChange = new EventEmitter<Array<any>>();
  @Input() selectAll: boolean = false;
  @ContentChildren('card') cards!: QueryList<TemplateRef<any>>;

  ngOnInit(): void {
    this.data = this.data.map(data => {
      return {...data, checklist: false}
    });
    console.log(this.data);
    this.dataChange.emit(this.data);
  }

  checkAll(ev: any) {
    this.data.forEach(x => x.checklist = ev.checked)
    this.dataChange.emit(this.data);
  }

  isAllChecked() {
    return this.data.every(_ => _.checklist);
  }

  onClickCard(event:any, value: any) {
      value.checklist = !value.checklist;
      this.dataChange.emit(this.data);
  }
}
